import {DocumentData, FirestoreDataConverter, QueryDocumentSnapshot, SnapshotOptions} from 'firebase/firestore';
import {BaseFirebaseModel} from '../bases/baseFirebaseModel';

export class Question extends BaseFirebaseModel {
	static questionConverter: FirestoreDataConverter<Question, DocumentData> = {
		toFirestore: (question: Question): DocumentData => {
			return {
				id: question.id,
				uuid: question.id,
				question: question.question,
				question_en: question.question_en,
				tag: question.tag
			} as DocumentData;
		},
		fromFirestore: (snapshot: QueryDocumentSnapshot<DocumentData>, options?: SnapshotOptions): Question => {
			const data = snapshot.data(options);
			const question = new Question(data);
			question.uuid = snapshot.id;
			return question;
		}
	};
	public question: string = '';
	public question_en: string = '';
	public tag: string[] = [];
	public value: number = 50;
	public changed: boolean = false;
	public id!: number;

	constructor(obj?: Record<string, unknown>) {
		super();
		Object.assign(this, obj);
	}

	public get img() {
		return '../../assets/test/' + this.id + '.webp';
	}

	public override toString() {
		return this.question + ' : ' + this.id;
	}
}
